import styled, { keyframes } from 'styled-components';

const drawerSlideIn = keyframes`
  from { transform: translateX(32px); opacity: 0; }
  to { transform: translateX(0); opacity: 1; }
`;

interface FormBuilderWrapperProps {

  $railTop?: number;

  $railWidth?: number;

  /* Width of the field properties drawer (wider than the idle rail: payment
     and option editors lay out in columns). */
  $drawerWidth?: number;

  $toolboxWidth?: number;

  /* Horizontal padding of the form Paper, so field rows can bleed to its edge
     by cancelling it with a negative margin. */
  $paperPaddingX?: number;
}

export const FormBuilderWrapper = styled.div<FormBuilderWrapperProps>`
  position: relative;
  width: 100%;
  display: block;

  .react-form-builder {
    width: 100%;
  }

  .react-form-builder-preview {
    width: 100%;
  }

  /* Property editor is an OVERLAY drawer on the right: nothing in the layout
     reserves space for it, so the canvas keeps full width and the drawer only
     covers part of it while a field is selected. */
  .edit-form {
    position: fixed !important;
    right: 0 !important;
    left: auto !important;
    top: 0 !important;
    bottom: 0 !important;
    width: ${(p) => p.$drawerWidth ?? p.$railWidth ?? 320}px !important;
    max-width: 92vw !important;
    animation: ${drawerSlideIn} 0.22s ease-out;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    -webkit-overflow-scrolling: touch;
    z-index: 1260 !important;
    background: var(--admin-surface) !important;

    padding: 20px 20px 80px 20px !important;
    border-left: 1px solid var(--admin-border) !important;
    border-right: none !important;
    box-shadow: -12px 0 32px rgba(15, 23, 42, 0.14) !important;
  }

  .edit-form:empty {
    display: none !important;
  }

  /* The library's dismiss "x" is the only way it exposes closing the panel.
     Float it into the sticky header strip drawn by .edit-form::before. */
  /* Fixed, not absolute: the drawer scrolls, and an absolutely positioned
     child would scroll out of the sticky header with it. */
  .dismiss-edit {
    position: fixed !important;
    top: ${(p) => (p.$railTop ?? 60) + 14}px !important;
    right: 16px !important;
    z-index: 1261 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 26px !important;
    height: 26px !important;
    border-radius: 6px !important;
    color: var(--admin-text-muted) !important;
    font-size: 14px !important;
    cursor: pointer !important;
    transition: background-color 0.15s ease, color 0.15s ease !important;
  }

  .dismiss-edit:hover {
    background: var(--admin-hover) !important;
    color: var(--admin-text) !important;
  }

  p {
    margin-bottom: 0px;
  }

  .btn-toolbar {
    justify-content: flex-end;
  }

  .save_btn {
    position: absolute;
    right: 10px;
    top: 0px;
  }

  .react-form-builder .react-form-builder-preview {
    background: none;
    border: none;
    padding: 0px;
    box-shadow: none;
  }

  img {
    object-fit: scale-down;
  }

  .react-form-builder-form .rfb-item img {
    max-width: 100%;
    margin-bottom: 15px;
  }

  .edit-form {
    .row {
      background: transparent !important;
      width: 100% !important;
      padding: 0px !important;
      margin: 0 !important;
 
      display: flex !important;
      flex-wrap: nowrap !important;
      align-items: center !important;
      gap: 8px !important;
    }

 
    .dynamic-option-list ul {
      list-style: none !important;
      padding: 0 !important;
      margin: 0 !important;
    }
    .dynamic-option-list ul li {
      margin: 0 0 10px 0 !important;
    }

     .dynamic-option-list ul li input,
    .dynamic-option-list ul li button,
    .dynamic-option-list ul li .dynamic-options-actions-buttons {
      float: none !important;
      margin: 0 !important;
    }

 
    .dynamic-option-list ul li [class*='col-'] {
      padding: 0 !important;
    }

   
    .dynamic-option-list ul li:first-child b {
      font-size: 12px !important;
      font-weight: 600 !important;
      color: var(--admin-text-muted) !important;
      text-transform: uppercase !important;
      letter-spacing: 0.02em !important;
    }
   
    .dynamic-option-list ul li:first-child .row {
      margin-bottom: 2px !important;
    }
 
    .dynamic-option-list ul li .row {
      gap: 6px !important;
    }

 
    .dynamic-option-list ul li .col-sm-6 {
      flex: 1 1 auto !important;
      min-width: 60px !important;
      width: auto !important;
    }

    .dynamic-option-list ul li .col-sm-2 {
      flex: 0 0 130px !important;
      width: 130px !important;
    }
 
    .dynamic-option-list ul li .col-sm-1,
    .dynamic-option-list ul li .col-sm-4 {
      flex: 0 0 44px !important;
      width: 44px !important;
      text-align: center !important;
    }
   
    .dynamic-option-list ul li .col-sm-3 {
      flex: 0 0 62px !important;
      width: 62px !important;
    }

     .dynamic-option-list ul li .dynamic-options-actions-buttons {
      display: flex !important;
      flex-direction: row !important;
      flex-wrap: nowrap !important;
      justify-content: flex-end !important;
      gap: 4px !important;
    }
    .dynamic-option-list ul li .dynamic-options-actions-buttons .btn {
      padding: 3px 6px !important;
      font-size: 11px !important;
      line-height: 1 !important;
      min-width: 0 !important;
      width: auto !important;
      flex: 0 0 auto !important;
    }

     .dynamic-option-list ul li .col-sm-6 input.form-control,
    .dynamic-option-list ul li .col-sm-2 input.form-control {
      height: auto !important;
      padding: 5px 8px !important;
      width: 100% !important;
    }

 
    .dynamic-option-list ul li .col-sm-1 input.form-control[type='checkbox'] {
      width: 18px !important;
      height: 18px !important;
      min-height: 0 !important;
      padding: 0 !important;
      margin: 0 auto !important;
      display: inline-block !important;
      vertical-align: middle !important;
      accent-color: var(--admin-accent) !important;
      cursor: pointer !important;
    }
  }
  .react-form-builder .react-form-builder-preview {
  }

  /* Every row spans the width its SortableItem gives it. The item already
     cancels the paper's padding (full-bleed margin) and re-applies it, so a row
     that adds its own width/padding on top lands on a different right edge than
     its neighbours — which is exactly what a stray "width: 75%; padding: 0 20px"
     here used to do: nested rows were overridden back to 100% below, top-level
     rows were not, so multi-column fields ran wider than plain ones. */
  .react-form-builder-preview .row {
    width: 100%;
    padding: 0;
    margin: 0 !important;
    background: transparent;
    border: none !important;
  }

  .react-form-builder-preview .rfb-item .row {
    border: none !important;
    border-radius: 0 !important;
    margin-top: 0 !important;
    padding: 0 !important;
  }

  .react-form-builder-preview .col > .row,
  .react-form-builder-preview [class*='col-md-'] .row,
  .react-form-builder-preview .SortableItem .row {
    width: 100% !important;
    padding: 0 !important;
    margin: 0 !important;
    display: flex !important;
    flex-wrap: wrap !important;
    gap: 16px !important;
  }

 
  .react-form-builder-preview [class*='col-md-'] {
    flex: 1 1 0 !important;
    max-width: none !important;
    min-width: 0 !important;
    padding: 0 !important;
  }


  .react-form-builder-preview .Sortable .rfb-item.SortableItem * {
    box-sizing: border-box !important;
    max-width: 100% !important;
  }

  .react-form-builder-preview .Sortable .rfb-item.SortableItem {
    box-sizing: border-box !important;
  }

  .react-form-builder-preview .Sortable .rfb-item.SortableItem .form-control,
  .react-form-builder-preview .Sortable .rfb-item.SortableItem input,
  .react-form-builder-preview .Sortable .rfb-item.SortableItem select,
  .react-form-builder-preview .Sortable .rfb-item.SortableItem textarea {
    width: 100% !important;
    min-width: 0 !important;
  }


  .react-form-builder-preview .Sortable .rfb-item.SortableItem input[type='checkbox'],
  .react-form-builder-preview .Sortable .rfb-item.SortableItem input[type='radio'] {
    width: auto !important;
  }

  .react-form-builder-preview .Sortable .rfb-item.SortableItem .row > * {
    min-width: 0 !important;
    flex-shrink: 1 !important;
  }

  /* Each field is a full-bleed row separated by a hairline, rather than a
     boxed card — the row spans the paper's full width, so the negative inline
     margin cancels the paper's own horizontal padding. */
  .react-form-builder
    .react-form-builder-preview
    .Sortable
    .rfb-item.SortableItem {
    border: none !important;
    border-bottom: 1px solid #eef0f3 !important;
    border-radius: 0 !important;
    background-color: transparent !important;
    margin: 0 -${(p) => p.$paperPaddingX ?? 32}px !important;
    padding: 18px ${(p) => p.$paperPaddingX ?? 32}px !important;
    box-sizing: border-box !important;
    width: calc(100% + ${(p) => (p.$paperPaddingX ?? 32) * 2}px) !important;
    max-width: calc(100% + ${(p) => (p.$paperPaddingX ?? 32) * 2}px) !important;
    min-width: 0 !important;
    position: relative !important;
    transition: background-color 0.15s ease !important;
  }

  .react-form-builder
    .react-form-builder-preview
    .Sortable
    .rfb-item.SortableItem:last-of-type {
    border-bottom: none !important;
  }

  /* Selected field: dashed accent outline across the whole row (drawn inset so
     it never widens the row and shifts the layout). */
  .react-form-builder
    .react-form-builder-preview
    .Sortable
    .rfb-item.SortableItem.is-editing {
    outline: 1.5px dashed #10b981 !important;
    outline-offset: -1.5px !important;
    border-radius: 6px !important;
    background-color: rgba(16, 185, 129, 0.04) !important;
  }

  .react-form-builder
    .react-form-builder-preview
    .Sortable
    .rfb-item.SortableItem
    .form-group {
    pointer-events: none;
    /* The row itself supplies the vertical rhythm now (see its padding), so
       the form-group must not add a second gap on top of it. */
    margin-bottom: 0 !important;
    padding: 0 !important;
    display: block !important;
    flex-direction: unset !important;
    flex-wrap: unset !important;
  }

  .react-form-builder
    .react-form-builder-preview
    .Sortable
    .rfb-item.SortableItem
    .form-group
    label,
  .react-form-builder
    .react-form-builder-preview
    .Sortable
    .rfb-item.SortableItem
    .form-group
    span {
    display: block !important;
    white-space: normal !important;
    word-break: normal !important;
    word-wrap: normal !important;
  }

  .react-form-builder-preview .col-md-12 > div {
    border: none !important;
    background-color: transparent !important;
  }

  .react-form-builder .react-form-builder-toolbar {
    margin: 0 !important;
    padding: 0 !important;
    position: fixed !important;
    left: 0 !important;
    right: auto !important;
    top: ${(p) => p.$railTop ?? 60}px !important;
    bottom: 0 !important;
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
    z-index: 999 !important;
    background: var(--admin-surface) !important;
    border-right: 1px solid var(--admin-border) !important;
    border-left: none !important;
    width: ${(p) => p.$toolboxWidth ?? 360}px !important;
    overflow: hidden !important;
  }

  /* Outer list is just a vertical stack of sections; the inner lists hold
     the draggable cards. */
  .react-form-builder .react-form-builder-toolbar > ul {
    overflow-y: auto !important;
    visibility: visible !important;
    opacity: 1 !important;
    list-style: none !important;
    display: block !important;
    /* leave room for the search bar (~61px), which FormBuilder renders as a
       fixed overlay on top of this rail */
    margin: 61px 0 0 0 !important;
    height: calc(100% - 61px) !important;
    padding: 4px 16px 24px !important;
  }

  /* Section wrapper — the first heading needs no extra offset, the list
     already clears the search bar. */
  .react-form-builder .react-form-builder-toolbar .toolbar-group-item {
    margin-top: 18px !important;
  }

  .react-form-builder
    .react-form-builder-toolbar
    > ul
    > li:first-of-type
    .toolbar-group-item {
    margin-top: 8px !important;
  }

  /* Section heading — the library renders a toggle button; keep it looking
     like a static heading. */
  .react-form-builder .react-form-builder-toolbar .toolbar-group-item > button {
    padding: 0 0 10px 0 !important;
    border: none !important;
    background: transparent !important;
    color: var(--admin-text-muted) !important;
    font-size: 11px !important;
    font-weight: 600 !important;
    letter-spacing: 0.04em !important;
    text-transform: uppercase !important;
    text-align: left !important;
    text-decoration: none !important;
    width: 100% !important;
    cursor: default !important;
    pointer-events: none !important;
    box-shadow: none !important;
  }

  /* Sections stay expanded — they read as headings, not accordions. */
  .react-form-builder .react-form-builder-toolbar .toolbar-group-item .collapse {
    display: block !important;
    height: auto !important;
    visibility: visible !important;
  }

  /* Card grid inside each section */
  .react-form-builder .react-form-builder-toolbar .toolbar-group-item ul {
    list-style: none !important;
    margin: 0 !important;
    padding: 0 !important;
    display: grid !important;
    /* auto-FILL, not auto-fit: auto-fit collapses the empty tracks of a
       partly-filled last row, so a section with one card (Media) stretched it
       across the whole rail. auto-fill keeps the empty tracks, so every card
       keeps the same width as a full row's. */
    grid-template-columns: repeat(auto-fill, minmax(84px, 1fr)) !important;
    gap: 10px !important;
  }

  /* The group <li> itself is only a wrapper — strip the card styling. */
  .react-form-builder .react-form-builder-toolbar > ul > li {
    display: block !important;
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
    padding: 0 !important;
    margin: 0 !important;
    min-height: 0 !important;
  }

  .react-form-builder .react-form-builder-toolbar .toolbar-group-item ul li {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 8px !important;
    text-align: center !important;
    min-height: 84px !important;
    padding: 12px 6px !important;
    margin: 0 !important;
    border: 1px solid var(--admin-border) !important;
    border-radius: 10px !important;
    background: var(--admin-surface) !important;
    color: var(--admin-text-muted) !important;
    font-size: 11.5px !important;
    font-weight: 500 !important;
    line-height: 1.3 !important;
    cursor: grab !important;
    box-shadow: none !important;
    transition: border-color 0.15s ease, box-shadow 0.15s ease !important;
  }

  .react-form-builder
    .react-form-builder-toolbar
    .toolbar-group-item
    ul
    li:hover {
    border-style: dashed !important;
    border-width: 1.5px !important;
    box-shadow: none !important;
  }

  /* Hover border matches the section's own icon color (see per-section icon
     colors below) instead of one fixed accent. Border only — no background
     tint, which made the hovered card look selected rather than hovered. */
  .react-form-builder .react-form-builder-toolbar > ul > li:nth-of-type(1) .toolbar-group-item ul li:hover {
    border-color: #f59e0b !important;
  }
  .react-form-builder .react-form-builder-toolbar > ul > li:nth-of-type(2) .toolbar-group-item ul li:hover {
    border-color: #10b981 !important;
  }
  .react-form-builder .react-form-builder-toolbar > ul > li:nth-of-type(3) .toolbar-group-item ul li:hover {
    border-color: #6366f1 !important;
  }
  .react-form-builder .react-form-builder-toolbar > ul > li:nth-of-type(4) .toolbar-group-item ul li:hover {
    border-color: #3b82f6 !important;
  }
  .react-form-builder .react-form-builder-toolbar > ul > li:nth-of-type(5) .toolbar-group-item ul li:hover {
    border-color: #06b6d4 !important;
  }
  .react-form-builder .react-form-builder-toolbar > ul > li:nth-of-type(6) .toolbar-group-item ul li:hover {
    border-color: #ec4899 !important;
  }
  .react-form-builder .react-form-builder-toolbar > ul > li:nth-of-type(7) .toolbar-group-item ul li:hover {
    border-color: #8b5cf6 !important;
  }

  .react-form-builder
    .react-form-builder-toolbar
    .toolbar-group-item
    ul
    li:active {
    cursor: grabbing !important;
  }

  .react-form-builder .react-form-builder-toolbar .toolbar-group-item ul li i {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 36px !important;
    height: 36px !important;
    margin: 0 !important;
    background: transparent !important;
  }

  /* thin scrollbars everywhere inside the builder */
  *::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  *::-webkit-scrollbar-thumb {
    background: var(--admin-scrollbar);
    border-radius: 3px;
  }
  *::-webkit-scrollbar-track {
    background: transparent;
  }

  .react-form-builder
    .react-form-builder-toolbar
    ul
    ::-webkit-scrollbar-thumb {
    background-color: var(--admin-scrollbar);
    border-radius: 10px;
  }

  ::-webkit-scrollbar-track {
    width: 1px;
    height: 1px;
    background: var(--admin-divider) !important;
  }

  /* The rail is labelled by the search box, so the library's own "Toolbox"
     heading is redundant. */
  .react-form-builder .react-form-builder-toolbar h4 {
    display: none !important;
  }

  .react-form-builder
    .react-form-builder-preview
    .Sortable
    .rfb-item
    .toolbar-header
    .toolbar-header-buttons {
    position: absolute !important;
    /* Sits in the gutter OUTSIDE the paper: inside the row it covered the
       field's own input (rows are full-bleed, so there is no inner gutter). */
    right: -52px !important;
    top: 12px !important;
    margin-top: 0 !important;
    background: #171a24 !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: stretch !important;
    width: 40px !important;
    visibility: hidden !important;
    opacity: 0 !important;
    z-index: 1000 !important;
    gap: 0 !important;
    padding: 0 !important;
    border-radius: 8px !important;
    overflow: hidden !important;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.28) !important;
    transition: opacity 0.15s ease !important;
  }

  .react-form-builder
    .react-form-builder-preview
    .Sortable
    .rfb-item:hover
    .toolbar-header
    .toolbar-header-buttons,
  .react-form-builder
    .react-form-builder-preview
    .Sortable
    .rfb-item
    .toolbar-header
    .toolbar-header-buttons:hover {
    visibility: visible !important;
    opacity: 1 !important;
  }

  .toolbar-header {
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
    position: relative !important;
    margin-bottom: 0 !important;
    padding-right: 0 !important;
    min-height: 0 !important;
  }

  .react-form-builder
    .react-form-builder-preview
    .Sortable
    .rfb-item
    .toolbar-header
    span.badge.badge-secondary {
    display: none !important;
  }

  /* Inside narrow columns the toolbar buttons (docked right) collided with
     the child's own type tag/label. Give each nested column item its own
     bordered box with breathing room and pull the buttons flush-right.
     Extra ancestor classes keep specificity above the generic
     ".Sortable .rfb-item.SortableItem { padding:0 }" reset above. */
  .react-form-builder
    .react-form-builder-preview
    .Sortable
    [class*='col-md-']
    [class*='col-md-']
    .rfb-item.SortableItem {
    border: 1px solid #e5e7eb !important;
    border-radius: 6px !important;
    padding: 10px !important;
    background: #fff !important;
  }

  .react-form-builder
    .react-form-builder-preview
    .Sortable
    [class*='col-md-']
    [class*='col-md-']
    .toolbar-header
    .toolbar-header-buttons {
    right: 6px !important;
  }

  /* The pill sits outside the field's own box (right: -44px), so the mouse
     crosses a dead gap between .rfb-item's edge and the pill, un-hovering
     .rfb-item before it reaches the buttons. Padding (not an absolutely
     positioned pseudo, which wouldn't be part of the hoverable box) closes
     that gap so the pointer never leaves .toolbar-header-buttons. */
  .toolbar-header-buttons {
    display: flex !important;
    flex-direction: column !important;
    align-items: stretch !important;
    gap: 0 !important;
    padding-left: 12px !important;
    margin-left: -12px !important;
  }

  .toolbar-header-buttons .btn {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    margin: 0 !important;
    width: 40px !important;
    height: 36px !important;
    padding: 0 !important;
    background: transparent !important;
    border: none !important;
    border-radius: 0 !important;
    cursor: pointer !important;
    text-decoration: none !important;
    z-index: 1001 !important;
    line-height: 1.2 !important;
    transition: background 0.12s ease !important;
  }

  .toolbar-header-buttons .btn i {
    font-size: 15px !important;
    color: #cbd2e0 !important;
    transition: color 0.12s ease !important;
  }

  .toolbar-header-buttons .btn:hover {
    background: rgba(255, 255, 255, 0.1) !important;
  }

  .toolbar-header-buttons .btn:hover i {
    color: #ffffff !important;
  }


  .toolbar-header-buttons .btn:nth-child(2) {
    background: #f04452 !important;
  }

  .toolbar-header-buttons .btn:nth-child(2) i {
    color: #ffffff !important;
  }

  .toolbar-header-buttons .btn:nth-child(2):hover {
    background: #d9333f !important;
  }

  .react-form-builder-form .rfb-item {
    padding: 5px 0;
  }


  .edit-form .rdw-editor-wrapper {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
    overflow: hidden !important;
    border-radius: 8px !important;
  }

  .edit-form .rdw-editor-main {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
    border: 1px solid var(--admin-border) !important;
    border-top: none !important;
    border-radius: 0 0 8px 8px !important;
    padding: 10px 12px !important;
    min-height: 96px !important;
    max-height: 220px !important;
    overflow-y: auto !important;
    background: var(--admin-surface) !important;
    color: var(--admin-text) !important;
    font-size: 13px !important;
    line-height: 1.6 !important;
  }

  .edit-form .rdw-editor-main .public-DraftStyleDefault-block {
    margin: 0 !important;
    overflow-wrap: anywhere !important;
  }

  .edit-form .rdw-editor-main .DraftEditor-root,
  .edit-form .rdw-editor-main .DraftEditor-editorContainer,
  .edit-form .rdw-editor-main .public-DraftEditor-content {
    width: 100% !important;
    max-width: 100% !important;
    word-break: break-word !important;
  }

  /* ── Property drawer chrome ──────────────────────────────────────────
     The library emits an unstyled stack of labels and inputs. Give it a
     proper drawer look: a sticky title, stacked label-over-control rows,
     and hairline separators between logical groups. */

  .edit-form::before {
    content: 'Field Properties';
    position: sticky !important;
    top: -20px !important;
    display: block !important;
    margin: -20px -20px 4px -20px !important;
    padding: 16px 20px !important;
    background: var(--admin-surface) !important;
    border-bottom: 1px solid var(--admin-divider) !important;
    color: var(--admin-text) !important;
    font-size: 14px !important;
    font-weight: 700 !important;
    z-index: 9999 !important;
  }


  .edit-form > *,
  .edit-form .form-group > * {
    max-width: 100% !important;
    box-sizing: border-box !important;
  }


  .edit-form .form-group {
    display: block !important;
    flex-direction: unset !important;
    align-items: unset !important;
    gap: 0 !important;
    /* Group spacing only slightly exceeds the label-to-control gap, so a label
       still reads as bound to the control BELOW it rather than floating
       midway between two fields. */
    margin: 0 0 20px 0 !important;
  }

  .edit-form .form-label,
  .edit-form .form-group > label {
    display: block !important;
    width: 100% !important;
    margin-bottom: 8px !important;
    color: var(--admin-text-secondary) !important;
    font-size: 12.5px !important;
    font-weight: 600 !important;
    line-height: 1.4 !important;
  }

  .edit-form .form-group .help-block,
  .edit-form .form-group small,
  .edit-form > div > small {
    display: block !important;
    margin-top: 6px !important;
    color: var(--admin-text-muted) !important;
    font-size: 11.5px !important;
    line-height: 1.5 !important;
  }

  .edit-form input[type='text'],
  .edit-form input[type='number'],
  .edit-form select {
    height: 38px !important;
    padding: 0 10px !important;
  }

  /* The native chevron sits in the browser's own padding box, which the fixed
     height above collapses — so it vanished. Suppress it and draw the arrow as
     a background image, leaving room for it on the right. */
  .edit-form select {
    -webkit-appearance: none !important;
    -moz-appearance: none !important;
    appearance: none !important;
    padding-right: 32px !important;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%236b7280' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E") !important;
    background-repeat: no-repeat !important;
    background-position: right 10px center !important;
    background-size: 16px 16px !important;
  }

  /* IE/Edge legacy arrow would double up with the drawn one. */
  .edit-form select::-ms-expand {
    display: none !important;
  }


  .edit-form .form-control.w-50 {
    width: 100% !important;
  }

  .edit-form input[type='text'],
  .edit-form input[type='number'],
  .edit-form select,
  .edit-form textarea {
    width: 100% !important;
    border: 1px solid var(--admin-border) !important;
    border-radius: 8px !important;
    /* background-COLOR, not the shorthand: the shorthand resets
       background-image and would erase the select's drawn chevron above. */
    background-color: var(--admin-surface) !important;
    color: var(--admin-text) !important;
    font-size: 13px !important;
    font-family: inherit !important;
    box-shadow: none !important;
    transition: border-color 0.15s ease, box-shadow 0.15s ease !important;
  }

  .edit-form textarea {
    padding: 9px 10px !important;
    line-height: 1.6 !important;
    resize: vertical !important;
  }

  .edit-form input[type='text']:hover,
  .edit-form input[type='number']:hover,
  .edit-form select:hover,
  .edit-form textarea:hover {
    border-color: var(--admin-border-strong) !important;
  }

  .edit-form input[type='text']:focus,
  .edit-form input[type='number']:focus,
  .edit-form select:focus,
  .edit-form textarea:focus {
    border-color: var(--admin-accent) !important;
    box-shadow: 0 0 0 3px var(--admin-accent-ring) !important;
    outline: none !important;
  }

  .edit-form .custom-control,
  .edit-form .form-group.form-check {
    display: flex !important;
    align-items: center !important;
    gap: 8px !important;
    min-height: 0 !important;
    padding-left: 0 !important;
    margin-left: 0 !important;
  }

  .edit-form input[type='checkbox']:not(.MuiSwitch-input) {
    width: 15px !important;
    height: 15px !important;
    margin: 0 !important;
    flex-shrink: 0 !important;
    accent-color: var(--admin-accent) !important;
  }

  .edit-form input[type='checkbox'].MuiSwitch-input {
    left: -100% !important;
    width: 300% !important;
    height: 100% !important;
    min-height: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
    border: 0 !important;
    opacity: 0 !important;
    cursor: pointer !important;
  }

  .edit-form .custom-control label,
  .edit-form .form-check label {
    margin: 0 !important;
    font-size: 13px !important;
    font-weight: 500 !important;
    color: var(--admin-text) !important;
  }

  .edit-form h4,
  .edit-form h5,
  .edit-form .form-group > b {
    display: block !important;
    margin: 22px 0 10px !important;
    padding-top: 16px !important;
    border-top: 1px solid var(--admin-divider) !important;
    color: var(--admin-text-muted) !important;
    font-size: 11px !important;
    font-weight: 600 !important;
    letter-spacing: 0.04em !important;
    text-transform: uppercase !important;
  }

  .edit-form .rdw-editor-toolbar {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
    display: flex !important;
    flex-wrap: wrap !important;
    align-items: center !important;
    gap: 4px 2px !important;
    margin-bottom: 0 !important;
    padding: 6px !important;
    border: 1px solid var(--admin-border) !important;
    border-bottom: none !important;
    border-radius: 8px 8px 0 0 !important;
    background: var(--admin-head-bg) !important;
  }

  .edit-form .rdw-option-wrapper {
    min-width: 26px !important;
    height: 26px !important;
    padding: 4px !important;
    margin: 0 !important;
    border: none !important;
    border-radius: 5px !important;
    background: transparent !important;
    box-shadow: none !important;
    transition: background 0.12s ease !important;
  }

  .edit-form .rdw-option-wrapper:hover {
    background: var(--admin-hover) !important;
    box-shadow: none !important;
  }

  .edit-form .rdw-option-active {
    background: var(--admin-segment-bg) !important;
    box-shadow: none !important;
  }

  [data-mode='dark'] & .edit-form .rdw-option-wrapper img {
    filter: invert(1) !important;
  }

  .edit-form .rdw-option-disabled {
    opacity: 0.35 !important;
  }

  .edit-form .rdw-inline-wrapper,
  .edit-form .rdw-list-wrapper,
  .edit-form .rdw-textalign-wrapper,
  .edit-form .rdw-link-wrapper,
  .edit-form .rdw-history-wrapper {
    display: flex !important;
    align-items: center !important;
    flex-wrap: nowrap !important;
    gap: 1px !important;
    margin: 0 10px 0 0 !important;
    padding: 0 !important;
    border: none !important;
  }

  .react-form-builder-preview .form-group,
  .react-form-builder-preview .rfb-item .form-group {
    display: block !important;
    flex-direction: unset !important;
    flex-wrap: unset !important;
    align-items: unset !important;
    gap: 0 !important;
    margin: 0 !important;
  }

  .react-form-builder .react-form-builder-preview .Sortable .rfb-item .form-group > label {
    margin-bottom: 8px !important;
    font-size: 14px !important;
    font-weight: 600 !important;
    line-height: 1.4 !important;
  }

  .react-form-builder-preview .form-group label,
  .react-form-builder-preview .rfb-item .form-group label {
    display: inline !important;
    white-space: normal !important;
    word-break: normal !important;
    word-wrap: normal !important;
  }
  .react-form-builder
    .react-form-builder-preview
    .Sortable
    .rfb-item.SortableItem
    .form-group
    label {
    display: flex !important;
  }

  .react-form-builder-preview .form-group input,
  .react-form-builder-preview .form-group textarea,
  .react-form-builder-preview .rfb-item .form-group input,
  .react-form-builder-preview
    .rfb-item
    .form-group
    textarea {
    display: block !important;
    white-space: normal !important;
    word-break: normal !important;
  }

  @media (min-width: 768px) {
    .col-md-3 {
      max-width: 20%;
    }

    .col-md-9 {
      max-width: 100%;
    }
  }

  @media (max-width: 900px) {
    .react-form-builder .react-form-builder-toolbar {
      bottom: 0;
      top: auto !important;
    }

    .react-form-builder .react-form-builder-toolbar ul {
      overflow-y: auto;
      overflow-x: auto;
    }
  }

  .action-buttons {
    position: absolute;
    right: 10px;
    top: 0px;
  }

  .btn {
    font-size: inherit;
  }

  h3 {
    font-size: 28px !important;
  }

  h4 {
    margin-bottom: 15px !important;
    font-size: 18px !important;
  }

  @media (max-width: 426px) {
    h3 {
      font-size: 20px !important;
    }

    p {
      font-size: 12px;
    }
  }

  /* ── shadcn/ui "Sheet" look for the properties drawer ────────────────
     Neutral slate tokens, hairline border, shadow-lg, 0.5rem radius and the
     focus ring shadcn uses (2px ring + 2px offset). Kept last so it wins over
     the chrome above. */
  .edit-form {
    --sh-background: var(--admin-surface);
    --sh-foreground: var(--admin-text);
    --sh-muted-foreground: var(--admin-text-muted);
    --sh-border: var(--admin-border);
    --sh-border-strong: var(--admin-border-strong);
    --sh-accent: var(--admin-hover);
    --sh-ring: var(--admin-accent);
    --sh-danger: var(--admin-danger);
    --sh-danger-soft: var(--admin-danger-soft);
    --sh-radius: 0.5rem;

    padding: 24px 24px 96px 24px !important;
    background: var(--sh-background) !important;
    color: var(--sh-foreground) !important;
    border-left: 1px solid var(--sh-border) !important;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1) !important;
    font-family: inherit !important;
  }

  .edit-form::before {
    top: -24px !important;
    margin: -24px -24px 20px -24px !important;
    padding: 20px 56px 16px 24px !important;
    border-bottom: 1px solid var(--sh-border) !important;
    color: var(--sh-foreground) !important;
    font-size: 18px !important;
    font-weight: 600 !important;
    letter-spacing: -0.01em !important;
    line-height: 1 !important;
  }

  .dismiss-edit {
    top: 20px !important;
    right: 16px !important;
    width: 28px !important;
    height: 28px !important;
    border-radius: 4px !important;
    color: var(--admin-text) !important;
    opacity: 0.7 !important;
    transition: opacity 0.15s ease !important;
  }

  .dismiss-edit:hover {
    background: transparent !important;
    opacity: 1 !important;
  }

  .dismiss-edit:focus-visible {
    outline: none !important;
    box-shadow: 0 0 0 2px var(--admin-surface), 0 0 0 4px var(--admin-accent) !important;
  }

  .edit-form .form-group {
    margin: 0 0 16px 0 !important;
  }

  .edit-form .form-label,
  .edit-form .form-group > label,
  .edit-form .control-label {
    margin-bottom: 8px !important;
    color: var(--sh-foreground) !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    line-height: 1 !important;
  }

  .edit-form .form-group .help-block,
  .edit-form .form-group small,
  .edit-form > div > small {
    margin-top: 8px !important;
    color: var(--sh-muted-foreground) !important;
    font-size: 13px !important;
    line-height: 1.4 !important;
  }

  .edit-form input[type='text'],
  .edit-form input[type='number'],
  .edit-form select {
    height: 40px !important;
    padding: 0 12px !important;
  }

  .edit-form select {
    padding-right: 32px !important;
  }

  .edit-form input[type='text'],
  .edit-form input[type='number'],
  .edit-form select,
  .edit-form textarea {
    border: 1px solid var(--sh-border) !important;
    border-radius: calc(var(--sh-radius) - 2px) !important;
    font-size: 14px !important;
    color: var(--sh-foreground) !important;
  }

  .edit-form input.form-control-sm,
  .edit-form select.form-control-sm {
    height: 36px !important;
    font-size: 13px !important;
  }

  .edit-form input[type='text']::placeholder,
  .edit-form input[type='number']::placeholder,
  .edit-form textarea::placeholder {
    color: var(--sh-muted-foreground) !important;
  }

  .edit-form input[type='text']:hover,
  .edit-form input[type='number']:hover,
  .edit-form select:hover,
  .edit-form textarea:hover {
    border-color: var(--sh-border-strong) !important;
  }

  .edit-form input[type='text']:focus,
  .edit-form input[type='number']:focus,
  .edit-form select:focus,
  .edit-form textarea:focus {
    outline: none !important;
    border-color: var(--sh-ring) !important;
    box-shadow: 0 0 0 2px var(--sh-background), 0 0 0 4px var(--sh-ring) !important;
  }

  /* shadcn Button, outline variant, sm size. */
  .edit-form .btn.btn-sm,
  .edit-form .btn-outline-secondary,
  .edit-form .btn-outline-danger,
  .edit-form .btn-outline-primary {
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    height: 36px !important;
    padding: 0 12px !important;
    border: 1px solid var(--sh-border) !important;
    border-radius: calc(var(--sh-radius) - 2px) !important;
    background: var(--sh-background) !important;
    color: var(--sh-foreground) !important;
    font-size: 13px !important;
    font-weight: 500 !important;
    line-height: 1 !important;
    transition: background-color 0.15s ease, color 0.15s ease !important;
  }

  .edit-form .btn.btn-sm:hover:not(:disabled),
  .edit-form .btn-outline-secondary:hover:not(:disabled),
  .edit-form .btn-outline-primary:hover:not(:disabled) {
    background: var(--sh-accent) !important;
  }

  .edit-form .btn-outline-danger {
    color: var(--sh-danger) !important;
  }

  .edit-form .btn-outline-danger:hover:not(:disabled) {
    background: var(--sh-danger-soft) !important;
  }

  .edit-form .btn:disabled {
    opacity: 0.5 !important;
    pointer-events: none !important;
  }

  .edit-form .btn:focus-visible {
    outline: none !important;
    box-shadow: 0 0 0 2px var(--sh-background), 0 0 0 4px var(--sh-ring) !important;
  }

  .edit-form .rfb-add-btn {
    height: 40px !important;
    margin: 4px 0 8px !important;
    padding: 0 16px !important;
    border: 1px dashed var(--sh-border-strong) !important;
    border-radius: calc(var(--sh-radius) - 2px) !important;
    background: var(--sh-background) !important;
    color: var(--sh-muted-foreground) !important;
    font-size: 13px !important;
    font-weight: 500 !important;
  }

  .edit-form .rfb-add-btn:hover {
    border-color: var(--sh-ring) !important;
    background: var(--sh-accent) !important;
    color: var(--sh-foreground) !important;
  }

  .edit-form .rfb-add-btn:focus-visible {
    outline: none !important;
    box-shadow: 0 0 0 2px var(--sh-background), 0 0 0 4px var(--sh-ring) !important;
  }
`;
